import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  class: "gorda-lm-card",
  style: {"background":"var(--surface-card)","border-radius":"1.25rem","border":"1px solid var(--border-subtle)","box-shadow":"var(--shadow-card), 0 24px 70px rgba(20,23,39,.18)","width":"360px","max-width":"calc(100vw - 2rem)","overflow":"hidden","font-family":"'Open Sans', sans-serif"}
}
const _hoisted_3 = { style: {"padding":"2.4rem 2rem 1.9rem","display":"flex","flex-direction":"column","align-items":"center","text-align":"center"} }
const _hoisted_4 = { style: {"font-size":"1.05rem","font-weight":"700","color":"var(--text-heading)","letter-spacing":"-0.01em","line-height":"1.2"} }
const _hoisted_5 = {
  key: 0,
  style: {"margin-top":".4rem","font-size":".8rem","font-weight":"400","color":"var(--text-muted)"}
}

import {computed} from 'vue'
import {storeToRefs} from 'pinia'
import {useThemeStore} from '@/services/stores/ThemeStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingToast',
  props: {
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



const {isDark} = storeToRefs(useThemeStore())
const backdropBg = computed(() => (isDark.value ? 'rgba(8, 11, 20, .92)' : 'rgba(233, 236, 239, .66)'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "gorda-lm-fade" }, {
    default: _withCtx(() => [
      (__props.isLoading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "gorda-lm-backdrop",
            role: "status",
            "aria-live": "polite",
            "aria-busy": "true",
            "aria-label": _ctx.$t('common.messages.waiting'),
            style: _normalizeStyle([{ background: backdropBg.value }, {"position":"fixed","inset":"0","z-index":"2000","backdrop-filter":"blur(4px)","-webkit-backdrop-filter":"blur(4px)","display":"flex","align-items":"center","justify-content":"center"}])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { style: {"position":"relative","width":"84px","height":"84px","margin-bottom":"1.4rem"} }, [
                  _createElementVNode("div", { style: {"position":"absolute","inset":"0","border-radius":"50%","border":"6px solid var(--border-subtle)"} }),
                  _createElementVNode("div", {
                    class: "gorda-lm-ring",
                    style: {"position":"absolute","inset":"0","border-radius":"50%","background":"conic-gradient(from 90deg, rgba(203,12,159,0) 8%, #cb0c9f 62%, #ff0080 100%)","-webkit-mask":"radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px))","mask":"radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px))"}
                  }),
                  _createElementVNode("div", {
                    class: "gorda-lm-core",
                    style: {"position":"absolute","top":"50%","left":"50%","width":"18px","height":"18px","margin-top":"-9px","margin-left":"-9px","border-radius":"50%","background":"var(--gradient-primary)","box-shadow":"0 4px 12px rgba(203,12,159,.35)"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('common.messages.waiting')), 1),
                (_ctx.$te('common.messages.waitingSub'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('common.messages.waitingSub')), 1))
                  : _createCommentVNode("", true)
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"position":"relative","height":"4px","overflow":"hidden","background":"var(--border-subtle)"} }, [
                _createElementVNode("div", {
                  class: "gorda-lm-seg",
                  style: {"position":"absolute","top":"0","bottom":"0","left":"0","width":"28%","border-radius":"4px","background":"var(--gradient-primary)"}
                })
              ], -1))
            ])
          ], 12, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})